// @flow
// const debug = require('debug')('facebookMiddleware');

const UPDATE_LOGIN_STATUS = 'facebook/UPDATE_LOGIN_STATUS';
const LOGIN = 'facebook/LOGIN';
const LOGIN_STATUS = 'facebook/LOGIN_STATUS';
const LOGOUT = 'facebook/LOGOUT';

type Action =
  | {| type: typeof UPDATE_LOGIN_STATUS |}
  | {| type: typeof LOGIN |}
  | {| type: typeof LOGOUT |};

type Event = typeof LOGIN_STATUS;

export const actions: { [string]: (any) => Action } = {
  updateLoginStatus: () => ({ type: UPDATE_LOGIN_STATUS }),
  login: () => ({ type: LOGIN }),
  logout: () => ({ type: LOGOUT })
};

export const events: { [string]: Event } = {
  LOGIN_STATUS
};

const types = [UPDATE_LOGIN_STATUS, LOGIN, LOGOUT];

let loadFB = () => {
  const promise = new Promise(resolve => {
    const script = document.createElement('script');
    const appId = process.env.FACEBOOK_API_KEY || '';
    script.textContent = `
      (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js#version=v2.12&appId=${appId}";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    `;
    window.document.body.appendChild(script);
    // no onload event for scripts without a src :(
    const init = () =>
      setTimeout(() => {
        if (!window.FB) return init();
        window.FB.init({
          appId: process.env.FACEBOOK_API_KEY,
          autoLogAppEvents: true,
          version: 'v2.12'
        });
        return resolve();
      }, window.FB ? 0 : 100);
    init();
    return actions.updateLoginStatus();
  });
  // Only load the script once ever
  loadFB = () => promise;
  return promise;
};

export default (store: any) => (next: (...args: Array<any>) => any) => (
  action: Action
): any => {
  if (types.indexOf(action.type) === -1) {
    return next(action);
  }

  if (typeof window.FB === 'undefined') {
    const load = loadFB();
    return new Promise(resolve =>
      load.then(() => store.dispatch(action).then(resolve))
    );
  }

  const { FB } = window;

  switch (action.type) {
    case UPDATE_LOGIN_STATUS: {
      const promise = new Promise(resolve => {
        FB.getLoginStatus(res => {
          store.dispatch({ type: LOGIN_STATUS, payload: res });
          resolve(res);
        });
      });
      return promise;
    }

    case LOGIN: {
      const promise = new Promise((resolve, reject) => {
        FB.login(
          res => {
            if (res.authResponse) {
              store.dispatch({ type: LOGIN_STATUS, payload: res });
              resolve(res.authResponse);
            } else {
              reject(res);
            }
          },
          {
            scope: 'public_profile,email'
          }
        );
      });
      return promise;
    }

    case LOGOUT: {
      break;
    }

    default: {
      return next(action);
    }
  }

  return next(action);
};
